import styled from 'styled-components'

interface IStyleProps {
  background?: string
  color?: string
}

export const Container = styled.div`
  width: fit-content;
  max-width: calc(100% - 20px);
  overflow: scroll;
  .grid-item {
    max-width: 100%;
    /* width: 100%; */
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
  }

  .grid-item p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .status-container {
    display: flex;
    justify-content: start;
    align-items: center;
    border-bottom: 1px solid rgb(238, 238, 238);
  }
  .receipt-container {
    display: flex;
    justify-content: center;
    align-items: center;

    border-bottom: 1px solid rgb(238, 238, 238);
  }
  .receipt-disabled {
    cursor: not-allowed;
    filter: brightness(0) saturate(100%) invert(93%) sepia(1%) saturate(0%)
      hue-rotate(172deg) brightness(93%) contrast(92%);
  }

  .grid-action-btn {
    background-color: transparent;
    border: none;
    cursor: pointer;
  }
`

export const Status = styled.p`
  padding: 6px 8px;
  background-color: ${(props: IStyleProps) => {
    if (props.background) return props.background
    return '#FDAB3D1A'
  }};
  color: ${(props: IStyleProps) => {
    if (props.color) return props.color
    return '#FDAB3D'
  }};
  font-weight: 500;
  font-size: 14px;
  line-height: 26px;
  border-radius: 10px;
  white-space: nowrap;
`
